











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { smsAreaCodeListApi } from "@/api/signIn";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() areaCode!: any;
  @Prop() single!: boolean;
  selectedObject: any = {};
  selectedList: any[] = [];
  dialogVisible = false;
  searchInfo = {
    key_word: "",
  };
  tableData: any[] = [];
  tableArr: any[] = [];
  showDialog() {
    this.dialogVisible = true;
    this.getList();
  }
  handleSearch(v: any) {
    this.tableData = JSON.parse(JSON.stringify(this.tableArr));
    const arr: any = [];
    this.tableData.map((item: any, index: any) => {
      if (
        this.tableData[index].name.includes(v) ||
        this.tableData[index].code.includes(v)
      ) {
        arr.push(index);
      }
    });
    this.tableData = this.tableData.filter((v, i) => {
      return arr.includes(i);
    });
  }
  getList() {
    smsAreaCodeListApi().then((res: any) => {
      if (res.error_code === 0) {
        res.data.ncn_list.unshift(...res.data.cn_list);
        res.data.ncn_list.map((item: any) => {
          if (this.selectedObject[item.code_id]) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        });
        this.tableData = res.data.ncn_list;
        this.tableData.map((item: any) => {
          if (item.code === this.areaCode) {
            this.selectedList = [];
            this.selectedList.push(item);
            item.checked = true;
          }
        });
        this.tableArr = JSON.parse(JSON.stringify(this.tableData));
      }
    });
  }
  handleAreaCodeSelect(data: any) {
    if (!data.checked) {
      data.checked = true;
    }
    let code_id = "";
    this.tableData.map((item: any) => {
      if (item.code_id !== data.code_id) {
        item.checked = false;
      } else {
        code_id = item.code_id;
        data = item;
      }
    });
    this.tableArr.map((item) => {
      if (item.code_id == code_id) {
        item.checked = true;
      } else {
        item.checked = false;
      }
    });
    this.selectedList = [];
    this.selectedList.push(data);
  }
  // handledelAreaCodeSelect(data:any) {
  //   this.tableData.map((item:any) => {
  //     if (item.code_id === data.code_id) {
  //       item.checked = false;
  //       this.selectedList = [];
  //     }
  //   })
  // }
  handleCancel() {
    this.dialogVisible = false;
    this.selectedObject = {};
    this.selectedList = [];
    this.searchInfo.key_word = "";
  }
  handleConfirm() {
    this.dialogVisible = false;
    this.$emit("change", this.selectedList);
  }
  handleSelectionChange(val: any) {}
}
